import { fetch } from "./http";

const controller: string = "v1/security/oauth2/";

export const getAmadeusToken = async () => {
  // if (
  //   origin === "http://localhost:5173" ||
  //   origin === "http://localhost:5174" ||
  //   origin === "http://192.168.18.128:5173"
  // ) {
  const payload = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
  };
  try {
    const response = await fetch.Postx_www_form(
      controller + `token`,
      `grant_type=client_credentials&client_id=${payload?.client_id}&client_secret=${payload?.client_secret}`
    );
    if (response.status === 200) {
      const data = await response.json();
      return data;
    } else if (response.status === 201) {
      const data = await response.json();
      throw new Error(data);
    } else {
      throw new Error("Something went wrong");
    }
  } catch (error) {
    throw error;
  }
};

export const getAmadeusTokenSearch = async () => {
  const payload = {
    client_id: process.env.REACT_APP_CLIENT_ID2,
    client_secret: process.env.REACT_APP_CLIENT_SECRET2,
  };
  try {
    const response = await fetch.Postx_www_form_traveler(
      controller + `token`,
      `grant_type=client_credentials&client_id=${payload?.client_id}&client_secret=${payload?.client_secret}`
    );
    if (response.status === 200) {
      const data = await response.json();
      return data;
    } else if (response.status === 201) {
      const data = await response.json();
      throw new Error(data);
    } else {
      throw new Error("Something went wrong");
    }
  } catch (error) {
    throw error;
  }
};
